import React from "react";
import { Box, Stack, Chip, Paper, CircularProgress } from "@mui/material";
import style from "../../RFPDashboard/CampaignDetails/Campaign.module.css";
import Avatar from "../../../shared/utils/Avatar";

const AdminList = ({ kamdata, initialLoading }) => {
  return (
    <Paper
      sx={{
        pr: 0,
        height: 450,
        padding: 2,
        borderRadius: 2,
        boxShadow: 2,
        overflow: "hidden", // Prevent content from flowing outside the Paper
      }}
    >
      <div className="flex justify-between items-center">
        <h3 className="font-bold text-xl">Team Members</h3>
        <Chip
          label={`Count :${kamdata?.length ? kamdata?.length : "0"} `}
          sx={{
            backgroundColor: "#FFD98E",
            color: "#C77903",
          }}
        />
      </div>

      {/* Scrollable Stack */}
      {initialLoading && (!kamdata || kamdata.length === 0) ? (
        <div className="h-full flex items-center justify-center">
          <CircularProgress size={32} />
        </div>
      ) : kamdata && kamdata.length > 0 ? (
        <Stack
          spacing={2}
          sx={{
            maxHeight: 380,
            overflowY: "auto", // Allow vertical scrolling
          }}
          className={`mt-2 rounded-lg ${style["custom-scrollbar"]} mb-3 pb-4`} // Custom scrollbar styling
        >
          {kamdata?.map((member, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "",
                borderRadius: 2,
                p: 1,
              }}
              className="border "
            >
              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                className="w-full"
              >
                <Avatar
                  name={
                    member?.name?.charAt(0)?.toUpperCase() +
                    member?.name?.slice(1)
                  }
                ></Avatar>
                <Box className="w-full">
                  <div className="w-full">
                    <label className="text-xs md:text-lg text-[var(--heading-color) font-semibold">
                      {member?.name?.charAt(0)?.toUpperCase() +
                        member?.name?.slice(1)}
                    </label>
                  </div>
                  <label className="text-xs md:text-sm text-[var(--heading-color) ">
                    {member?.email}
                  </label>
                </Box>
                <Chip
                  label={
                    member?.role == 0
                      ? "Admin"
                      : member?.role == 1
                        ? "BD"
                        : "MT"
                  }
                  sx={{
                    backgroundColor: `${member?.role == 0
                      ? "#FFD98E"
                      : member?.role == 1
                        ? "#baf1ba"
                        : "#FFDFDF"
                      }`, // Custom background color
                    color: `${member?.role == 0
                      ? "#C77903"
                      : member?.role == 1
                        ? "#346034"
                        : "#8C0909"
                      }`, // Custom text color
                  }}
                />
              </Stack>
            </Box>
          ))}
        </Stack>
      ) : (
        <div className=" h-full flex items-center justify-center">
          <span>No Account Manager</span>
        </div>
      )}
    </Paper>
  );
};

export default AdminList;
